<template>
  <div>
    <app-header :module-navigation="navigation" module-name="E-commerce"></app-header>
    <main id="page-main" class="with-tabs">
      <router-view></router-view>
    </main>
  </div>
</template>
<script>
export default {
  data () {
    return {
      navigation: [
        {
          route: 'shop-dashboard',
          label: 'Dashboard',
          acl: null
        },
        {
          route: 'order',
          label: 'Commandes',
          acl: 'weeboxshop.order.vue'
        },
        {
          route: 'category',
          label: 'Catégories',
          acl: 'weeboxshop.category.vue'
        },
        {
          route: 'product',
          label: 'Produits',
          acl: 'weeboxshop.product.vue'
        },
        {
          route: 'inventory',
          label: 'Inventaire',
          acl: 'weeboxshop.inventory.vue'
        },
        {
          route: 'voucher',
          label: 'Coupons',
          acl: 'weeboxshop.voucher.vue'
        },
        {
          route: 'discount',
          label: 'Promotions',
          acl: 'weeboxshop.discount.vue'
        },
        {
          route: 'commercial-gesture',
          label: 'Gestes commerciaux',
          acl: 'weeboxshop.commercialgesture.vue'
        },
        {
          route: 'brand',
          label: 'Marques',
          acl: 'weeboxshop.brand.vue'
        },
        {
          route: 'product-type',
          label: 'Types',
          acl: 'weeboxshop.producttype.vue'
        },
        {
          route: 'product-option',
          label: 'Options',
          acl: 'weeboxshop.productoption.vue'
        },
        {
          route: 'shipping',
          label: 'Livraisons',
          acl: 'weeboxshop.shipping.vue'
        },
      ]
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/modules/shop/Index.vue